import { render, staticRenderFns } from "./sidebar-item.component.vue?vue&type=template&id=2efc79a8&scoped=true"
import script from "./sidebar-item.component.vue?vue&type=script&lang=js"
export * from "./sidebar-item.component.vue?vue&type=script&lang=js"
import style0 from "./sidebar-item.component.vue?vue&type=style&index=0&id=2efc79a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc79a8",
  null
  
)

export default component.exports